import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import api_client_reply = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_reply.alan_api;
import reQuery = require("./reQuery");
import * as addClientState from "../state/addClientState";
import { number_toBackendValue } from "../widgets/instructions/update";
import * as Collection from "../state/Collection";
import { iText } from "../state/Text";
import { iReference } from "../state/Reference";
import {
	registerSubscription,
	getCollectionUpdatesRegistration,
	getCollectionEntriesRegistration,
	getCollectionKeyRegistration,
	getCollectionRegistrations,
	initializeKeySubscription,
} from "../state/registerClientState";
import { IdPathBuilder } from "../navigation/IdPathBuilder";
import createIdPathBuilderFromReplyIdPath from "../navigation/createIdPathBuilderFromReplyIdPath";
import DestructorTree from "../DestructorTree";
import { nodeEditMode } from "../state/editMode";
import { Failed, Result } from "../Status";
import { Sink } from "../Symbols";
import { iGraph } from "../state/Graph";
import { iCollection } from "../state/Collection";
import { iStategroup, iState } from "../state/Stategroup";

function requeryNodeQueries(node: api_cs.Cnode) {
	for (const $ of node.properties.queries.values()) {
		reQuery.query($.properties.query);
	}
	for (const $ of node.properties.attributes.values()) {
		switch ($.properties.type.state.name) {
			case "operation":
				break;
			case "property": {
				const property = $.properties.type.state.node;
				switch (property.properties.type.state.name) {
					case "collection":
						break;
					case "file":
						break;
					case "group":
						requeryNodeQueries(property.properties.type.state.node.properties.node);
						break;
					case "number":
						break;
					case "state group": {
						const state_group = property.properties.type.state.node;
						for (const state of state_group.properties.states.values()) {
							switch (state.properties.is_selected.state.name) {
								case "yes":
									requeryNodeQueries(state.properties.node);
									break;
								case "no":
									break;
								default:
									unexpectedState(state.properties.is_selected.state);
							}
						}
						break;
					}
					case "text":
						break;
					default:
						unexpectedState(property.properties.type.state);
				}
				break;
			}
			default:
				unexpectedState($.properties.type.state);
		}
	}
}

export function setPropertiesToNotReadable(node: api_cs.Cnode) {
	node.properties.read_permitted.ensure("no", {});
	for (const attribute of node.properties.attributes.values()) {
		switch (attribute.properties.type.state.name) {
			case "operation":
				break;
			case "property": {
				const property = attribute.properties.type.state.node;
				switch (property.properties.type.state.name) {
					case "collection":
						break;
					case "file": {
						const $ = property.properties.type.state.node;
						$.properties.is_set.set("no", {});
						const backend_known = $.properties.backend_known.ensure("yes", {
							"is readable": ["no", {}],
						});
						backend_known.properties.is_readable.ensure("no", {});
						$.properties.is_valid.ensure("yes", {});
						break;
					}
					case "group": {
						const $ = property.properties.type.state.node;
						setPropertiesToNotReadable($.properties.node);
						break;
					}
					case "number": {
						const $ = property.properties.type.state.node;
						const backend_known = $.properties.backend_known.ensure("yes", {
							"is readable": ["no", {}],
						});
						backend_known.properties.is_readable.ensure("no", {});
						break;
					}
					case "state group": {
						const $ = property.properties.type.state.node;
						$.properties.initialized.ensure("no", {});
						break;
					}
					case "text": {
						const text = property.properties.type.state.node;
						text.properties.backend_known.ensure("no", {});
						switch (text.properties.navigable.state.name) {
							case "no":
								break;
							case "yes": {
								const $ = text.properties.navigable.state.node;
								$.properties.resolve_status.properties.status.ensure("failed to resolve", {});
								for (const [, rule] of $.properties.rules.properties.rules) {
									rule.properties.resolve_status.properties.status.ensure("failed to resolve", {});
								}
								break;
							}
							default:
								unexpectedState(text.properties.navigable.state);
						}
						break;
					}
					default:
						unexpectedState(property.properties.type.state);
				}
				break;
			}
			default:
				unexpectedState(attribute.properties.type.state);
		}
	}
}

function set_number_backend(
	number: api_cs.Cnumber__type__property,
	backend_value: number,
	permissions?: api_client_reply.Cpermission_data
) {
	number.properties.backend_known.set("yes", {
		"is readable": [
			"yes",
			{
				number: backend_value,
			},
		],
	});
	switch (number.properties.is_set.state.name) {
		case "yes":
			switch (number.properties.is_editable.state.name) {
				case "yes": {
					const editable = number.properties.is_editable.state.node;
					switch (editable.properties.modified.state.name) {
						case "yes": {
							const modified = editable.properties.modified.state.node;
							if (modified.properties.number.value === backend_value) {
								number_toBackendValue(number);
							}
							break;
						}
						case "no":
							number_toBackendValue(number);
							break;
						default:
							unexpectedState(editable.properties.modified.state);
					}
					break;
				}
				case "no":
					number_toBackendValue(number);
					break;
				default:
					unexpectedState(number.properties.is_editable.state);
			}
			break;
		case "no":
			number_toBackendValue(number);
			break;
		default:
			unexpectedState(number.properties.is_set.state);
	}
	if (permissions) {
		const number_definition = number.inferences.number_type();
		switch (number_definition.properties.type.state.name) {
			case "derived":
				break;
			case "base": {
				const base = number_definition.properties.type.state.node;
				switch (base.properties.type.state.name) {
					case "causal":
						break;
					case "simple":
						switch (permissions.properties.permitted.state.name) {
							case "no":
								number.properties.is_editable.ensure("no", {});
								break;
							case "yes":
								number.properties.is_editable.ensure("yes", {
									modified: ["no", {}],
									"edit mode": nodeEditMode(number.parent.parent.parent),
								});
								break;
							default:
								unexpectedState(permissions.properties.permitted.state);
						}
						break;
					default:
						unexpectedState(base.properties.type.state);
				}
				break;
			}
			default:
				unexpectedState(number_definition.properties.type.state);
		}
	}
}

function set_file_backend(
	file: api_cs.Cfile__type__property,
	backend_value: { token: string; extension: string },
	permissions?: api_client_reply.Cpermission_data
) {
	file.properties.is_set.set("yes", {
		token: backend_value.token,
		extension: backend_value.extension,
	});
	file.properties.is_valid.set("yes", {});
	file.properties.backend_known.set("yes", {
		"is readable": [
			"yes",
			{
				token: backend_value.token,
				extension: backend_value.extension,
			},
		],
	});
	if (permissions) {
		const file_definition = file.inferences.file_type();
		switch (file_definition.properties.type.state.name) {
			case "derived":
				break;
			case "base":
				switch (permissions.properties.permitted.state.name) {
					case "no":
						file.properties.is_editable.ensure("no", {});
						break;
					case "yes":
						file.properties.is_editable.ensure("yes", {
							modified: ["no", {}],
							"edit mode": nodeEditMode(file.parent.parent.parent),
						});
						break;
					default:
						unexpectedState(permissions.properties.permitted.state);
				}
				break;
			default:
				unexpectedState(file_definition.properties.type.state);
		}
	}
}

export function updateNodeFromNotificationData(
	node: api_cs.Cnode,
	notification_data: api_client_reply.Cnotification_data,
	destructor: DestructorTree
): void {
	for (const $property of notification_data.properties.properties.values()) {
		const property = node.properties.attributes.get($property.key.entry)?.properties.type.cast("property");
		if (property) {
			switch ($property.properties.type.state.name) {
				case "text": {
					const $text = $property.properties.type.state.node;
					const text = property.properties.type.cast("text");
					switch ($text.properties.value_update.state.name) {
						case "no":
							break;
						case "yes":
							iText(text).setServerValue($text.properties.value_update.state.node.properties.value);
					}
					switch ($text.properties.reference_update.state.name) {
						case "yes": {
							const $ = $text.properties.reference_update.state.node;
							let reference_update: Result<IdPathBuilder>;
							switch ($.properties.result.state.name) {
								case "node": {
									const $$ = $.properties.result.state.node;
									reference_update = createIdPathBuilderFromReplyIdPath($$.properties.id_path);
									break;
								}
								case "disconnected":
									reference_update = Failed;
									break;
								case "permission denied":
									reference_update = Failed;
							}
							iReference(text.properties.navigable.cast("yes")).setServerValue(reference_update);
							break;
						}
						case "no":
					}
					break;
				}
				case "number": {
					const $number = $property.properties.type.state.node;
					set_number_backend(property.properties.type.cast("number"), $number.properties.value.value);
					break;
				}
				case "file": {
					const $file = $property.properties.type.state.node;
					set_file_backend(property.properties.type.cast("file"), {
						token: $file.properties.token,
						extension: $file.properties.extension,
					});
					break;
				}
				case "group": {
					const $group = $property.properties.type.state.node;
					updateNodeFromNotificationData(
						property.properties.type.cast("group").properties.node,
						$group.properties.notification_data,
						destructor
					);
					break;
				}
				case "state group": {
					const $stategroup = $property.properties.type.state.node;
					const stategroup = property.properties.type.cast("state group");
					const backend_state_def = $stategroup.properties.state.ref.key.ref;
					const backend_state = stategroup.properties.states.get(backend_state_def.key)!;
					switch ($stategroup.properties.type.state.name) {
						case "set": {
							const $set = $stategroup.properties.type.state.node;
							const new_backend_state = stategroup.properties.states.get(backend_state_def.key)!;
							iState(new_backend_state).setServerState();
							iStategroup(stategroup).updatePermissions(
								$set.properties.delete_permitted.properties.permitted.state.name
							);
							updateNodeFromSubscriptionResultData(
								backend_state.properties.node,
								$set.properties.initialization_data,
								destructor
							);
							requeryNodeQueries(backend_state.properties.node);
							break;
						}
						case "update": {
							const $update = $stategroup.properties.type.state.node;
							switch (stategroup.properties.initialized.state.name) {
								case "no":
									stategroup.root.transact(() => {
										iState(backend_state).__server_state();
									});
									break;
								case "yes":
							}
							updateNodeFromNotificationData(
								backend_state.properties.node,
								$update.properties.notification_data,
								destructor
							);
							break;
						}
						default:
							unexpectedState($stategroup.properties.type.state);
					}
					break;
				}
				case "collection": {
					const $collection = $property.properties.type.state.node;
					const collection = property.properties.type.cast("collection");
					switch ($collection.properties.value_update.state.name) {
						case "no":
							break;
						case "updated":
							reQuery.queriesForCollectionFromNode(node, collection);
							// Remove marked entries
							for (const entry of collection.properties.entries.values()) {
								switch (entry.properties.location.state.name) {
									case "remote": {
										const $ = entry.properties.location.state.node;
										switch ($.properties.marked_for_deletion.state.name) {
											case "no":
												break;
											case "yes":
												iCollection(entry.parent).deleteServerEntry(entry);
												break;
											default:
												unexpectedState($.properties.marked_for_deletion.state);
										}
										break;
									}
									case "local":
										break;
									default:
										unexpectedState(entry.properties.location.state);
								}
							}
							iCollection(collection).updateAmountOfRemoteEntries();
							break;
						case "entries": {
							const $entries = $collection.properties.value_update.state.node;
							reQuery.queriesForCollectionFromNode(node, collection);

							switch ($collection.properties.graph_endpoints_update.state.name) {
								case "no":
									break;
								case "yes":
									switch ($collection.properties.graph_endpoints_update.state.node.properties.result.state.name) {
										case "none":
											for (const ordered_graph of collection.properties.has_ordered_graphs
												.cast("yes")
												.properties.ordered_graphs.values()) {
												iGraph(ordered_graph).setServerSourceValue(Sink);
											}
											break;
										case "endpoints":
											for (const [name, ordered_graph] of collection.properties.has_ordered_graphs.cast("yes")
												.properties.ordered_graphs) {
												iGraph(ordered_graph).setServerSourceValue(
													$collection.properties.graph_endpoints_update.state.node.properties.result.state.node.properties.graph_endpoints.get(
														name
													)?.properties.source ?? Sink
												);
											}
											break;
									}
									break;
							}

							for (const [key, $entry] of $entries.properties.entries) {
								let entry = Collection.getInitializedEntryWithKey(collection, key);
								switch ($entry.properties.type.state.name) {
									case "create": {
										const $ = $entry.properties.type.state.node;
										entry = addClientState.addRemoteEntry(collection, key);
										initializeKeySubscription(entry, key, destructor);
										switch ($.properties.delete_permitted.properties.permitted.state.name) {
											case "no":
												entry.properties.node.properties.can_be_deleted.set("no", {});
												entry.properties.key.ref.properties.is_editable.set("no", {});
												break;
											case "yes":
												entry.properties.node.properties.can_be_deleted.set("yes", {});
												break;
										}
										updateNodeFromSubscriptionResultData(entry.properties.node, $.properties.node_data, destructor);
										break;
									}
									case "remove":
										if (entry !== undefined) {
											iCollection(entry.parent).deleteServerEntry(entry);
										}
										break;
									case "update": {
										const $ = $entry.properties.type.state.node;
										if (entry !== undefined) {
											updateNodeFromNotificationData(entry.properties.node, $.properties.node_data, destructor);
										}
										break;
									}
									default:
										unexpectedState($entry.properties.type.state);
								}
							}

							iCollection(collection).updateAmountOfRemoteEntries();
							break;
						}
						default:
							unexpectedState($collection.properties.value_update.state);
					}
					break;
				}
				default:
					unexpectedState($property.properties.type.state);
			}
		}
	}
}

export function updateNodeFromSubscriptionResultData(
	node: api_cs.Cnode,
	subscription_result_data: api_client_reply.Csubscription_result_data,
	destructor: DestructorTree
): void {
	const update_permissions = subscription_result_data.properties.update_permitted;
	switch (subscription_result_data.properties.read_permitted.state.name) {
		case "no":
			setPropertiesToNotReadable(node);
			break;
		case "yes": {
			const readable = subscription_result_data.properties.read_permitted.state.node;
			for (const [attribute_name, $att] of readable.properties.attributes) {
				const attribute = node.properties.attributes.get(attribute_name);
				if (attribute) {
					switch ($att.properties.type.state.name) {
						case "command": {
							const $command = $att.properties.type.state.node;
							const command = attribute.properties.type.cast("operation").properties.type.cast("command");
							switch ($command.properties.execute_permitted.properties.permitted.state.name) {
								case "no": {
									command.properties.execute_permitted.set("no", {});
									break;
								}
								case "yes": {
									command.properties.execute_permitted.set("yes", {});
									break;
								}
								default:
									unexpectedState($command.properties.execute_permitted.properties.permitted.state);
							}
							registerSubscription(command, destructor);
							break;
						}
						case "property": {
							const $property = $att.properties.type.state.node;
							const property = attribute.properties.type.cast("property");
							switch ($property.properties.type.state.name) {
								case "text": {
									const $text = $property.properties.type.state.node;
									const text = property.properties.type.cast("text");
									iText(text).setServerValue($text.properties.value);
									iText(text).updatePermissions(update_permissions.properties.permitted.state.name);

									switch ($text.properties.reference_result.state.name) {
										case "yes": {
											let backend_reference: Result<IdPathBuilder>;
											const $ = $text.properties.reference_result.state.node;
											switch ($.properties.result.state.name) {
												case "node": {
													const $$ = $.properties.result.state.node;
													backend_reference = createIdPathBuilderFromReplyIdPath($$.properties.id_path);
													break;
												}
												case "disconnected":
													backend_reference = Failed;
													break;
												case "permission denied":
													backend_reference = Failed;
											}
											iReference(text.properties.navigable.cast("yes")).setServerValue(backend_reference);
											break;
										}
										case "no":
									}
									registerSubscription(text, destructor);
									break;
								}
								case "number": {
									const $number = $property.properties.type.state.node;
									const number = property.properties.type.cast("number");
									set_number_backend(number, $number.properties.value.value, update_permissions);
									registerSubscription(number, destructor);
									break;
								}
								case "file": {
									const $file = $property.properties.type.state.node;
									const file = property.properties.type.cast("file");
									set_file_backend(
										file,
										{
											token: $file.properties.token,
											extension: $file.properties.extension,
										},
										update_permissions
									);
									registerSubscription(file, destructor);
									break;
								}
								case "group": {
									const $group = $property.properties.type.state.node;
									const group = property.properties.type.cast("group");
									registerSubscription(group, destructor);
									updateNodeFromSubscriptionResultData(group.properties.node, $group.properties.node_data, destructor);
									break;
								}
								case "state group": {
									const $stategroup = $property.properties.type.state.node;
									const stategroup = property.properties.type.cast("state group");
									const backend_state = stategroup.properties.states.get($stategroup.properties.state.entry)!;
									iState(backend_state).setServerState();
									iStategroup(stategroup).updatePermissions(
										$stategroup.properties.delete_permitted.properties.permitted.state.name
									);
									for (const [state_name, state] of backend_state.parent.properties.states) {
										if ($stategroup.properties.create_permitted.has(state_name)) {
											state.properties.create_permitted.set("yes", {});
										} else {
											state.properties.create_permitted.set("no", {});
										}
									}
									registerSubscription(stategroup, destructor);
									updateNodeFromSubscriptionResultData(
										backend_state.properties.node,
										$stategroup.properties.node_data,
										destructor
									);
									break;
								}
								case "collection": {
									const $collection = $property.properties.type.state.node;
									const collection = property.properties.type.cast("collection");

									switch ($collection.properties.create_permitted.properties.permitted.state.name) {
										case "yes":
											collection.properties.can_create_entry.set("yes", {});
											collection.properties.is_editable.set("yes", {
												"edit mode": nodeEditMode(collection.parent.parent.parent),
											});
											break;
										case "no":
											collection.properties.can_create_entry.set("no", {});
											collection.properties.is_editable.set("no", {});
											break;
										default:
											unexpectedState($collection.properties.create_permitted.properties.permitted.state);
									}

									switch ($collection.properties.graph_endpoints_result.state.name) {
										case "no":
											break;
										case "yes":
											switch ($collection.properties.graph_endpoints_result.state.node.properties.result.state.name) {
												case "none":
													for (const ordered_graph of collection.properties.has_ordered_graphs
														.cast("yes")
														.properties.ordered_graphs.values()) {
														iGraph(ordered_graph).setServerSourceValue(Sink);
													}
													break;
												case "endpoints":
													for (const [name, ordered_graph] of collection.properties.has_ordered_graphs.cast("yes")
														.properties.ordered_graphs) {
														iGraph(ordered_graph).setServerSourceValue(
															$collection.properties.graph_endpoints_result.state.node.properties.result.state.node.properties.graph_endpoints.get(
																name
															)?.properties.source ?? Sink
														);
													}
													break;
											}
											break;
									}

									switch ($collection.properties.result.state.name) {
										case "update":
											registerSubscription(getCollectionUpdatesRegistration(collection), destructor);
											break;
										case "entries": {
											const $entries = $collection.properties.result.state.node;
											const subscribe_on_entries = $entries.inferences.subscribe_on_entries();

											for (const [key, $entry] of $entries.properties.entries) {
												const entry = addClientState.addRemoteEntry(collection, key);
												const entry_node = entry.properties.node;
												switch ($entry.properties.delete_permitted.properties.permitted.state.name) {
													case "no":
														entry_node.properties.can_be_deleted.set("no", {});
														entry.properties.key.ref.properties.is_editable.set("no", {});
														break;
													case "yes":
														entry_node.properties.can_be_deleted.set("yes", {});
														break;
													default:
														unexpectedState($entry.properties.delete_permitted.properties.permitted.state);
												}
												initializeKeySubscription(entry, key, destructor);
												updateNodeFromSubscriptionResultData(entry_node, $entry.properties.node_data, destructor);
											}

											// Collection updates are implicitly also subscribed to
											registerSubscription(getCollectionUpdatesRegistration(collection), destructor);
											// Find entries that were expected in the result but did not exist
											switch (subscribe_on_entries.properties.key_filter.state.name) {
												case "no": {
													registerSubscription(getCollectionEntriesRegistration(collection), destructor);
													// walk all the keys in the registration
													const key_registrations = getCollectionRegistrations(collection).keys;
													for (const key_registration of key_registrations.values()) {
														registerSubscription(key_registration, destructor);
													}
													break;
												}
												case "yes": {
													const $ = subscribe_on_entries.properties.key_filter.state.node;
													for (const [key] of $.properties.keys) {
														registerSubscription(getCollectionKeyRegistration(collection, key), destructor);
													}
													break;
												}
												default:
													unexpectedState(subscribe_on_entries.properties.key_filter.state);
											}
											break;
										}
										default:
											unexpectedState($collection.properties.result.state);
									}
									iCollection(collection).updateAmountOfRemoteEntries();
									break;
								}
								default:
									unexpectedState($property.properties.type.state);
							}
							break;
						}
						default:
							unexpectedState($att.properties.type.state);
					}
				}
			}
			break;
		}
		default:
			unexpectedState(subscription_result_data.properties.read_permitted.state);
	}
}

export function updateNodeFromSubscriptionResult(
	node: api_cs.Cnode,
	existing_subscription_context: api_client_reply.Cexists__context__subscription,
	destructor: DestructorTree
): void {
	switch (existing_subscription_context.properties.delete_permitted.properties.permitted.state.name) {
		case "no": {
			node.properties.can_be_deleted.set("no", {});
			break;
		}
		case "yes": {
			node.properties.can_be_deleted.set("yes", {});
			break;
		}
		default:
			unexpectedState(existing_subscription_context.properties.delete_permitted.properties.permitted.state);
	}
	updateNodeFromSubscriptionResultData(
		node,
		existing_subscription_context.properties.subscription_result_data,
		destructor
	);
}
